import {
  BooleanInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

export const ChangeFileForm = () => (
  <SimpleForm>
    <TextInput source="description" fullWidth />
    <BooleanInput source="is_active" />
    <ReferenceInput source="model_id" reference="models" label="Модель">
      <SelectInput source="id" label="Модель" optionText="name" />
    </ReferenceInput>
  </SimpleForm>
);
